import { useEffect, useState } from 'react'
import { placeholderGeneral } from '../components/customUtils/Constants'
import { searchFile } from '../components/customUtils/Components/ImageWIthZoom'
import { validateConnectionNetwork } from '../utils/functions.utils'

const useImageLoader = (uri: string, path: string) => {
    const [image, setImage] = useState<string>(placeholderGeneral)
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const getImageItem = async () => {
            setLoading(true)
            let image = await searchFile(uri, path)
            if (image && image !== '') {
                setImage(image)
            } else {
                const hasConnection = await validateConnectionNetwork()
                setImage(hasConnection ? uri : placeholderGeneral)
            }
            setLoading(false)
        }
        getImageItem()
    }, [uri, path])

    return { image, loading, placeholderGeneral }
}

export default useImageLoader
